module.exports = __webpack_public_path__ + "6f7d336d1deadf376f0f076784238c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background/plain.png
// module id = 112
// module chunks = 0